import React from 'react'
import {Route, Redirect} from 'react-router'
import asyncComponent from '../../core/components/async-component/AsyncComponent'

const AsyncEditor = asyncComponent({
  loader: () => import('./components/Editor'),
  modules: ['./components/Editor'],
  webpack: () => [require.resolveWeak('./components/Editor')]
})

// The keys are required for rendering an array like this, but to us this
// serves no purpose.
const EditorRoute = [
  <Redirect
    from='/editor/:editOrCreate(edit|create)/:type(explanation|problem|problem_solution)/:illFormedTopicId(.*[^0-9].*)' 
    to='/404'
    key='editorRedirect'
  />,
  <Route exact path='/editor/create/explanation/:topicId([0-9]+)'
    render={routeProps => (
      <AsyncEditor {...routeProps} type='createExplanation' titleText='Creating an explanation' />
    )}
    key='createExplanation'
  />,
  <Route exact path='/editor/create/problem/:topicId([0-9]+)' 
    render={routeProps => (
      <AsyncEditor {...routeProps} type='createProblem' titleText='Creating a problem' />
    )}
    key='createProblem'
  />,
  <Route exact path='/editor/create/problem_solution/:problemId([0-9]+)' 
    render={routeProps => (
      <AsyncEditor {...routeProps} type='createSolution' titleText='Creating a solution' />
    )}
    key='createSolution'
  />,
  <Route exact path='/editor/edit/explanation/:explanationId([0-9]+)'
    render={routeProps => (
      <AsyncEditor {...routeProps} type='editExplanation' titleText='Editing an explanation' />
    )}
    key='editExplanation'
  />,
  <Route exact path='/editor/edit/problem/:problemId([0-9]+)'
    render={routeProps => (
      <AsyncEditor {...routeProps} type='editProblem' titleText='Editing a problem' />
    )}
    key='editProblem'
  />,
  <Route exact path='/editor/edit/problem_solution/:solutionId([0-9]+)'
    render={routeProps => (
      <AsyncEditor {...routeProps} type='editSolution' titleText='Editing a solution' />
    )}
    key='editSolution'
  />
]
export default EditorRoute



// WEBPACK FOOTER //
// ./src/domains/editor_v3/index.js